import {
  anUpdateThresholdRule,
  aThresholdRule,
  mockUpdateThresholdRuleBuilderOperationMutation,
  UpdateThresholdRuleBuilderOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

import { THRESHOLD_RULE_DATA } from '../queries/RuleBuilderQueryOperation.mocks';

export const updateThresholdRuleResponse: UpdateThresholdRuleBuilderOperationMutation =
  {
    __typename: 'Mutation',
    // @ts-ignore windowSizeInMillisecnds is aliased which causes issues with typing since MSW doesn't handle this case
    updateThresholdRule: anUpdateThresholdRule({
      data: {
        ...aThresholdRule({
          id: THRESHOLD_RULE_DATA.ruleId,
          ruleType: 'threshold',
        }),
        // @ts-ignore windowSizeInMillisecnds is aliased which causes issues with typing since MSW doesn't handle this case
        windowSizeMilliseconds: THRESHOLD_RULE_DATA.windowSizeInMilliseconds,
      },
    }),
  };

export const handlers = [
  mockUpdateThresholdRuleBuilderOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: updateThresholdRuleResponse,
      });
    }
  ),
];
